// src/views/Notifications.js
import React from 'react';

const Notifications = () => {
  
  console.log('this is the notification page');
  return <div>Notifications Page</div>;
};

export default Notifications;